/**
 * Persistent lightweight reminder that Ask Aura is available for app navigation help.
 * Replaces auto-start driver.js tours on login / page change.
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { LifebuoyIcon } from '@heroicons/react/24/outline';

const AskAuraHint = ({ user }) => {
  const location = useLocation();

  if (!user || !(user.portfolio_connected || user.onboarding_complete)) {
    return null;
  }

  // Cashflow has a dedicated Ask Aura panel; avoid overlapping that layout.
  if (location.pathname.startsWith('/cashflow')) {
    return null;
  }

  return (
    <div
      className="fixed bottom-6 left-4 md:left-6 z-40 pointer-events-none max-w-[min(100vw-8rem,22rem)]"
      role="status"
      aria-live="polite"
    >
      <div className="pointer-events-auto flex items-start gap-2.5 px-3 py-2.5 surface-panel">
        <LifebuoyIcon className="w-5 h-5 text-pine shrink-0 mt-0.5" aria-hidden />
        <p className="text-xs text-secondary leading-snug">
          Stuck or exploring? Tap <span className="text-pine font-medium">Ask Aura</span>{' '}
          (bottom-right) anytime — your guide for finding features and getting around Aura.
        </p>
      </div>
    </div>
  );
};

export default AskAuraHint;
